module.exports = __webpack_public_path__ + "static/media/Carly Bartman_1636488760609.0d44e533.jpeg";